var icon = require('vue-svgicon')
icon.register({
  'ks-icon-pdf': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M68.2 51.4h23.1L68.2 28.3v23.1M38.8 22h33.6l25.2 25.2v50.4a8.4 8.4 0 0 1-8.4 8.4H38.8a8.4 8.4 0 0 1-8.4-8.4V30.4a8.4 8.4 0 0 1 8.4-8.4M56 61.48c-.08.17-1.22 7.39-8.82 19.7 0 0-14.7 7.64-11.21 13.35 2.81 4.54 9.74-.16 15.7-11.25a76.62 76.62 0 0 1 17.83-3.45s16.21 7.27 18.44-.46-12.85-6.05-15.54-5.25c0 0-8.4-5.67-10.5-13.48 0 0 4.79-16.59-2.56-16.38S54.76 57.41 56 61.48m3.4 4.37a31.85 31.85 0 0 0 7.94 10.33S57.57 78.11 53.12 80a80.72 80.72 0 0 0 6.3-14.11m16.51 11.38c2.43-.67 9.78.63 9.49 2s-9.49-2-9.49-2M46.23 85c-2.22 5.21-6 8.4-7 8.4s2.94-6.72 7-8.4m13.19-29.11c0-.29-1.51-9.24 0-9 2.27.31 0 8.71 0 9z"/>'
  }
})
